/**
 * Facebook/Meta Pixel: PageView (toda navegação) e Lead (só quando o backend
 * confirma leadPendente=true - uma vez por pessoa, para sempre; a fonte da
 * verdade é o banco, este arquivo só reflete o que o servidor manda).
 *
 * Nunca dispara fora de produção (import.meta.env.PROD) para não sujar o
 * dataset com testes locais. window.fbq vem do snippet base do Meta em
 * index.html, carregado antes de qualquer código do app rodar.
 */
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

const PROD = import.meta.env.PROD;

function pixelDisponivel(): boolean {
  return PROD && typeof window !== 'undefined' && typeof window.fbq === 'function';
}

export function pixelPageView(): void {
  if (!pixelDisponivel()) return;
  window.fbq!('track', 'PageView');
}

/**
 * eventID determinístico ('<userId>-lead') para o Meta deduplicar caso o client
 * dispare mais de uma vez por race (ex.: reconexão, retry de rede). Nenhum dado
 * pessoal (e-mail, nome, WhatsApp) vai nos parâmetros - o objeto custom fica vazio.
 */
export function pixelLead(userId: string): void {
  if (!pixelDisponivel()) return;
  window.fbq!('track', 'Lead', {}, { eventID: `${userId}-lead` });
}
